export * from './lib/shared-dtos-dashboards-gz-console';
